import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantBroadcastMessageService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_ParticipantBroadcastMessageDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetParticipantBroadcastMessageList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_ParticipantBroadcastMessageDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const ParticipantBroadcastMessageList = useQuery(
    ['getParticipantBroadcastMessageList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        ParticipantBroadcastMessageService.getApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessageList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return ParticipantBroadcastMessageList;
};

export default useGetParticipantBroadcastMessageList;
